import React, { Component } from "react";
import { connect } from "react-redux";

// Components
import Loader from "../../utils/Loader";
import StoreLocation from "./StoreLocation";

// State
import { getAllStores, resetStores } from "../../../store/actions/storeLocation";
import { setActiveCheckoutSection, setIsStore } from "../../../store/actions/checkout";
import { clearPickupDate } from "../../../store/actions/pickup";

// CSS
import "../../../css/delivery.css";

// Util
import {
	setCheckoutSectionActive as setCheckoutSectionActiveGA,
	setCheckoutSectionComplete as setCheckoutSectionCompleteGA
} from "../../../utils/google-analytics";

class DeliverySection extends Component {
	componentDidMount() {
		this.props.getAllStores();
		this.props.clearPickupDate("");
	}

	componentWillUnmount() {
		this.props.resetStores();
	}

	render() {
		const { stores, isLoading } = this.props;

		return (
			<div>
				<div className="delivery-heading">
					<h2>Choose a store near you:</h2>
					<button
						className={"btn btn--red btn--heading"}
						disabled={this.props.saving}
						onClick={() => {
							// Set current section as complete
							setCheckoutSectionCompleteGA(2);

							// Set Shipping active
							setCheckoutSectionActiveGA(3);
							this.props.setActiveCheckoutSection("shipping");

							// Set Location as non-store
							this.props.setIsStore(false);
						}}
					>
						<span>Ship To An Address</span>
					</button>
				</div>

				<div>
					{isLoading ? (
						<Loader />
					) : !isLoading && !!stores ? (
						stores.map((location, i) => (
							<StoreLocation key={i} location={location} saving={this.props.saving} />
						))
					) : (
								<div>
									There are no store locations to deliver to.
									<br />
							Ship to an address!
								</div>
							)}
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		stores: state.storeLocation.stores,
		isLoading: state.storeLocation.isLoading,
		saving: state.checkout.saving,
		pickup: state.pickup,
	};
};

export default connect(
	mapStateToProps,
	{
		getAllStores,
		resetStores,
		setActiveCheckoutSection,
		setIsStore,
		clearPickupDate,
	}
)(DeliverySection);



// WEBPACK FOOTER //
// ./src/components/checkout/delivery/DeliverySection.js